import * as React from 'react';
const SvgSlacklining = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    width={800}
    height={800}
    viewBox='0 0 58.719 58.719'
    {...props}
  >
    <circle
      cx={29.798}
      cy={12.376}
      r={3.374}
      style={{
        fill: props.fill || '#010002',
      }}
    />
    <path
      d='m58.607 45.556-26.292 3.146c1.03-.24 1.8-1.16 1.8-2.268V30.822c.038-.188.059-.387.059-.6v-1.734a1.575 1.575 0 0 0 0-.35v-8.485l9.568-2.438c1.993-.508 1.146-3.587-.849-3.079l-9.974 2.542c-.984-.564-2.334-.502-3.229.187L19.235 13.29c-1.947-.666-2.923 2.374-.975 3.041l10.483 3.586v7.735c-2.29 1.395-4.534 2.861-6.943 4.053-1.054.521-1.291 1.947-.761 2.902 1.195 2.16 2.362 4.336 3.537 6.508 1.301 2.406 4.965.264 3.665-2.143-.824-1.525-1.649-3.049-2.479-4.57 1.248-.699 2.466-1.449 3.683-2.201v14.236c0 1.123.794 2.061 1.854 2.283L.094 45.556 0 46.492l31.733 3.219.052.006 26.934-3.225-.112-.936z'
      style={{
        fill: props.fill || '#010002',
      }}
    />
  </svg>
);
export default SvgSlacklining;
